import ProductReview from '@src/quince-site-common/src/domains/ProductReview'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import Swiper from '../../custom-swiper'
import Image from '../../image'

// style
import styles from './productReviewGallerySlider.module.scss'

export interface ProductReviewGallerySliderProps {
  heading: string
  productReviews: ProductReview[]
  onReviewImageClick: (reviewId: number, imageIndex: number) => void
}

export const ProductReviewGallerySlider = (props: ProductReviewGallerySliderProps) => {
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP

  return (
    <div className={styles.gallaryWrap}>
      <div className={styles.galleryInner}>
        {props.heading && (
          <h4 data-testid="review-section-gallery-heading" className={styles.heading}>
            {props.heading}
          </h4>
        )}
        <Swiper
          id={'product-review-gallery-slider'}
          showNavigator={isDesktop}
          numberOfVisibleSlides={8}
          className={styles.gallerySliderWrap}
          virtualOptions={{ enabled: true }}
        >
          {props.productReviews.map((review: ProductReview) => {
            return review.imagesFileUrls?.map((fileUrl: string, imageIndex) => {
              return (
                <div
                  key={fileUrl}
                  onClick={() => {
                    props.onReviewImageClick(review.id, imageIndex)
                  }}
                  className={styles.slideItem}
                >
                  <Image
                    alt={'review-image'}
                    title={review.title}
                    url={fileUrl}
                    key={fileUrl}
                    className={styles.slideImage}
                    fillWithBlackBackground={false}
                    loading={'lazy'}
                  />
                </div>
              )
            })
          })}
        </Swiper>
      </div>
    </div>
  )
}

export default ProductReviewGallerySlider
